import permissions, { AppPermissions } from '../../authorization/Permissions';
import * as React from 'react';
import { RoleModel } from '../types/RoleModel';
import { CustomRole } from '../types';

export class UsersHelper {
    static isCustomRole = (r: unknown) => {
        const properties = Object.getOwnPropertyNames(r);
        return properties.includes('permissions');
    };

    static getPermissionsString = (role: string) => {
        if (permissions[role]) {
            const rolePermissions = permissions[role] as AppPermissions[];
            return rolePermissions.map(x => (
                <>
                    {x}
                    <br />
                </>
            ));
        }
        return null;
    };

    static getRolePermissions = (r: RoleModel | CustomRole) => {
        return this.isCustomRole(r)
            ? (r as CustomRole).permissions.map(p => (
                  <>
                      {p}
                      <br />
                  </>
              ))
            : this.getPermissionsString(r.name);
    };

    static getBasicRoles = (defaultRoles?: RoleModel[], customRoles?: CustomRole[]) => {
        if (!defaultRoles && !customRoles) {
            return [];
        }

        const allRoles: (RoleModel | CustomRole)[] = [...(defaultRoles ?? []), ...(customRoles ?? [])];
        return allRoles;
    };
}
